//console.log('js loaded');

//Import
import gsap from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import {Flip} from "gsap/Flip";
import {Scroll} from "./Scroll";
import {SplitText} from "gsap/SplitText";

import Swiper from 'swiper';

import { Navigation, Pagination } from 'swiper/modules';

const swiper = new Swiper('.one-slide', {
  effect: "fade",
  loop: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  }
});

const swiper2 = new Swiper('.three-slide', {
    slidesPerView: 1,
    spaceBetween: 0,
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
    breakpoints: {
        640: {
          slidesPerView: 1,
          spaceBetween: 0,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 32,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 32,
        },
    },
});


gsap.registerPlugin(ScrollTrigger,Flip,SplitText);

let spT2 = new SplitText(".home__hero-title", { type: "lines", linesClass: "lineChild" });
let spT1 = new SplitText(".home__hero-title", { type: "lines", linesClass: "lineParent" });

gsap.set(spT1.lines,{overflow:"hidden"});

/*

if (document.querySelectorAll('.fifb').length > 0) {

    document.querySelectorAll('.fifb').forEach(el=>{

        gsap.from(el, {
            opacity: 0,
            duration: .8,
            scrollTrigger: {
                trigger: el,
                markers: false,
                start: "top 75%",
            }
        });

    });
}

if (document.querySelectorAll('.fifs').length > 0) {

    document.querySelectorAll('.fifs').forEach(el=>{

        gsap.from(el, {
            scale: 0,
            opacity: 0,
            duration: .8,
            scrollTrigger: {
                trigger: el,
                markers: false,
                start: "top 75%",
            }
        });

    });
}


gsap.to('.home__contactsBox', {
    scale:1,
    scrollTrigger: {
        trigger: '.home__contactsBox',
        markers: false,
        start: "top 75%",
    }
});

gsap.to('.home__contactsBox span', {
    opacity:1,
    delay: .5,
    scrollTrigger: {
        trigger: '.home__contactsBox',
        markers: false,
        start: "top 75%",
    }
});

gsap.to('.home__contactsBtn', {
    opacity:1,
    scale:1,
    delay: .5,
    scrollTrigger: {
        trigger: '.home__contactsBox',
        markers: false,
        start: "top 75%",
    }
});

*/



setTimeout(()=>{

    if (document.querySelectorAll('.stagger-in').length > 0) {

        document.querySelectorAll('.stagger-in').forEach(el=>{


            let elements = el.querySelectorAll('.stagger-in__el')


            gsap.from(elements, {
                opacity: 0,
                duration: .8,
                yPercent:50,
                stagger: {
                    each: 0.1
                },
                scrollTrigger: {
                    trigger: el,
                    markers: false,
                    start: "top 75%",
                }
            });

            gsap.to(elements, {
                opacity: 1,
                duration: .8,
                stagger: {
                    each: 0.1
                },
                scrollTrigger: {
                    trigger: el,
                    markers: false,
                    start: "top 75%",
                }
            });

        });
    }


    Scroll.scrollTo(0, {
        immediate:true,
    })



    let elements = document.querySelectorAll('.element');

    elements.forEach((el,i)=>{
        const elementState = Flip.getState(el);

        document.querySelector(el.dataset.target).append(el);

        Flip.from(elementState, {
            duration: 1.5,
            delay: i*0.2,
            ease: "power1.inOut",
        });

        gsap.to(el, {
            opacity: 1,
            duration: 1.5,
            delay: i*0.2,
            ease: "power1.inOut",
        });



    });

},250);


document.querySelectorAll(".hamburger").forEach((element) => {
  element.addEventListener("click", (event) => {
    element.classList.toggle("is-active");
  });
});

const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
const toggleMenu = document.querySelector('.hamburger');


const tl = gsap.timeline({ reversed: true });
  
  tl
  .from('.header nav', {
    duration: 0.4,
    ease: 'power3.inOut',
    top: '-100%',    
  })
  .from('.header nav li', {
    duration: 0.3,
    opacity: 0,
    y: 20,
    ease: 'power3.inOut',
    stagger: 0.05,    
  });

  function animateIt() {    
    tl.reversed() ? tl.play() : tl.reverse()
  }




var mediaQueryList = window.matchMedia('(min-width: 991px)');

// Set things up on load
if(mediaQueryList.matches) {
  tl.pause(1)
} else {
  toggleMenu.addEventListener('click', animateIt);
  tl.pause(0)
}

function toggleStateOnResize(e) {
  
  if (e.matches) {
    // WIDE SCREEN
    toggleMenu.removeEventListener('click', animateIt);
    tl.pause(1)

  } else {
    // NARROW SCREEN
    toggleMenu.addEventListener('click', animateIt);
    tl.pause(0).reversed(true)
  }
}

mediaQueryList.addListener(toggleStateOnResize);
